import { jsx } from "react/jsx-runtime";
const Shield = ({ isHovered }) => {
  const normal = /* @__PURE__ */ jsx(
    "path",
    {
      d: "M39.618 12.49c-1.94-.515-7.682-2.28-15.617-6.817-7.936 4.538-13.68 6.302-15.618 6.818-.163 1.768-.455 6.828.825 12.354C11.268 33.74 16.245 39.653 24 42.422c7.755-2.77 12.73-8.681 14.792-17.577 1.28-5.526.988-10.586.825-12.354zM24.325 44.429l-.324.11-.324-.11C3.102 37.382 6.437 11.807 6.473 11.55l.097-.691.683-.148c.065-.014 6.62-1.475 16.246-7.057L24 3.363l.5.29c9.627 5.583 16.18 7.044 16.247 7.058l.682.148.097.69c.036.258 3.372 25.833-17.202 32.879zm8.54-26.672 1.44 1.387-11.987 12.455-7.306-7.592 1.44-1.387 5.866 6.095 10.547-10.958z",
      fillRule: "evenodd"
    }
  );
  const normalHover = /* @__PURE__ */ jsx(
    "path",
    {
      d: "M39.618 12.49c-1.94-.515-7.682-2.28-15.618-6.817-7.935 4.538-13.678 6.302-15.618 6.818-.163 1.768-.455 6.828.826 12.354C11.268 33.74 16.245 39.653 24 42.422c7.755-2.77 12.73-8.681 14.792-17.577 1.28-5.526.989-10.586.826-12.354zM24.325 44.429l-.325.11-.324-.11C3.102 37.382 6.436 11.807 6.473 11.55l.097-.691.683-.148c.065-.014 6.62-1.475 16.246-7.057l.5-.291.503.29c9.626 5.583 16.18 7.044 16.245 7.058l.682.148.098.69c.036.258 3.37 25.833-17.202 32.879zm9.77-27.95 1.44 1.388-13.217 13.732-5.934-6.165 1.442-1.386 4.492 4.667 11.777-12.235z",
      fillRule: "evenodd"
    }
  );
  return isHovered ? normalHover : normal;
};
export {
  Shield as default
};
//# sourceMappingURL=Shield.js.map
